import styles from './StageChip.module.css';

export type Stage = 'STAGE_1' | 'STAGE_2' | 'STAGE_3' | 'STAGE_4' | 'STAGE_5' | 'UA_OPS';

interface StageChipProps {
  stage: Stage;
}

const LABEL: Record<string, string> = {
  STAGE_1: 'Stage 1',
  STAGE_2: 'Stage 2',
  STAGE_3: 'Stage 3',
  STAGE_4: 'Stage 4',
  STAGE_5: 'Stage 5',
  UA_OPS: 'UA Ops',
};

const BG_CLASS: Record<string, string> = {
  STAGE_1: styles.stage1,
  STAGE_2: styles.stage2,
  STAGE_3: styles.stage3,
  STAGE_4: styles.stage4,
  STAGE_5: styles.stage5,
  UA_OPS: styles.uaOps,
};

const DOT_CLASS: Record<string, string> = {
  STAGE_1: styles.dot1,
  STAGE_2: styles.dot2,
  STAGE_3: styles.dot3,
  STAGE_4: styles.dot4,
  STAGE_5: styles.dot5,
  UA_OPS: styles.dotUaOps,
};

// 칩 없이 텍스트로만 Stage를 쓰는 화면(프로젝트 목록 등)이 같은 라벨을 쓰도록 공용 export.
export const stageLabel = (stage: Stage) => LABEL[stage] ?? stage;

export function StageChip({ stage }: StageChipProps) {
  const key = stage;
  return (
    <span className={[styles.chip, BG_CLASS[key]].join(' ')}>
      <span className={[styles.dot, DOT_CLASS[key]].join(' ')} />
      {LABEL[key]}
    </span>
  );
}
